// src/components/features/content/form-utils/contentFormData.js
import * as Yup from 'yup';

/**
 * Content type options
 */
export const CONTENT_TYPES = [
  { value: 'post', label: 'Post' },
  { value: 'story', label: 'Story' },
  { value: 'reel', label: 'Reel' },
  { value: 'video', label: 'Video' },
  { value: 'article', label: 'Article' },
  { value: 'carousel', label: 'Carousel' },
  { value: 'announcement', label: 'Announcement' },
  { value: 'promotion', label: 'Promotion' },
  { value: 'event', label: 'Event' }
];

/**
 * Language options
 */
export const LANGUAGE_OPTIONS = [
  { value: 'en', label: 'English' },
  { value: 'ar', label: 'Arabic' },
  { value: 'bilingual', label: 'Bilingual (English & Arabic)' }
];

/**
 * Platform options for distribution
 */
export const PLATFORM_OPTIONS = [
  { value: 'facebook', label: 'Facebook', color: '#1877F2' },
  { value: 'instagram', label: 'Instagram', color: '#E1306C' },
  { value: 'twitter', label: 'Twitter', color: '#1DA1F2' },
  { value: 'linkedin', label: 'LinkedIn', color: '#0077B5' },
  { value: 'youtube', label: 'YouTube', color: '#FF0000' },
  { value: 'tiktok', label: 'TikTok', color: '#000000' },
  { value: 'snapchat', label: 'Snapchat', color: '#FFFC00' }
];

/**
 * Asset types
 */
export const ASSET_TYPES = [
  { 
    value: 'image', 
    label: 'Image', 
    accept: 'image/*',
    maxSize: 5 * 1024 * 1024 // 5MB
  },
  { 
    value: 'video', 
    label: 'Video', 
    accept: 'video/*',
    maxSize: 100 * 1024 * 1024 // 100MB
  },
  { 
    value: 'audio', 
    label: 'Audio', 
    accept: 'audio/*',
    maxSize: 25 * 1024 * 1024 // 25MB
  },
  { 
    value: 'document', 
    label: 'Document', 
    accept: '.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx',
    maxSize: 20 * 1024 * 1024 // 20MB
  }
];

/**
 * Initial content data
 */
export const initialContentData = {
  title: '',
  type: 'post',
  text: '',
  category: '',
  language: 'bilingual',
  brandId: '',
  campaignId: '',
  hashtags: [],
  tags: [],
  assets: [],
  references: [],
  distributions: [],
  targetAudience: {
    age: {
      min: 18,
      max: 65
    },
    gender: 'all',
    interests: [],
    locations: []
  },
  link: null,
  isClientVisible: true
};

/**
 * Validation schema for basic content info
 */
export const basicInfoSchema = Yup.object({
  title: Yup.string().required('Title is required'),
  type: Yup.string().required('Content type is required'),
  category: Yup.string().required('Category is required'),
  brandId: Yup.string().required('Brand is required')
});

/**
 * Get default categories for content type
 */
export const getDefaultCategoriesForType = (contentType) => {
  switch (contentType) {
    case 'post':
    case 'carousel':
      return ['Product', 'Lifestyle', 'Promotional', 'Educational', 'Engagement', 'Brand Story', 'UGC', 'Behind the Scenes'];
    case 'story':
    case 'reel':
      return ['Quick Update', 'Feature Highlight', 'Day in the Life', 'Tutorial', 'Testimonial', 'Trend', 'Q&A'];
    case 'video':
      return ['Brand Video', 'Product Demo', 'Tutorial', 'Customer Story', 'Interview', 'Event Recap'];
    case 'article':
      return ['Blog Post', 'Case Study', 'News', 'Press Release', 'Thought Leadership'];
    case 'announcement':
      return ['Product Launch', 'Company News', 'Feature Update', 'Important Notice'];
    case 'promotion':
      return ['Sale', 'Discount', 'Special Offer', 'Seasonal Promotion', 'Event Promotion'];
    case 'event':
      return ['Webinar', 'Workshop', 'Conference', 'Launch Event', 'Meetup'];
    default:
      return ['General', 'Promotional', 'Educational', 'Engagement'];
  }
};